import React from "react";
import Section from "../components/shared/Section";
import ProductCard from "../components/shared/ProductCard";
import { productCategories } from "../data/products";

export default function Products() {
  return (
    <Section id="products">
      <h2 className="text-2xl sm:text-4xl font-semibold   text-center drop-shadow-[0_1px_8px_rgba(255,200,0,0.15)]">
        Products: <span className="text-yellow-700">SS Profiles / Inlays & Trims</span>
      </h2>
      <p className="mt-3 max-w-3xl text-neutral-300 mx-auto text-center">
        T / U / Transition Profiles / Tile Edge Profiles / Corner Protection Profiles / Solid Profiles / Stair Nosing Profiles / SS Decorative Sheets.
      </p>
      <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {productCategories.map((p) => (
          <ProductCard key={p.key} item={p} />
        ))}
      </div>
    </Section>
  );
}
